function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fish_outline_stroke{fill:none;stroke:currentColor;stroke-width:2;stroke-miterlimit:10;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "fish_outline"
}, /*#__PURE__*/React.createElement("path", {
  className: "fish_outline_fill",
  d: "M0.5,35.2c0-6.3,1.7-12.2,4.7-17.3c6-10.4,17.2-17.3,30-17.3s24,7,30,17.3c-6,10.4-17.2,17.3-30,17.3 s-24-7-30-17.3c-3-5.1-4.7-11-4.7-17.3V35.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fish_outline_stroke",
  d: "M0.5,35.2c0-6.3,1.7-12.2,4.7-17.3c6-10.4,17.2-17.3,30-17.3s24,7,30,17.3c-6,10.4-17.2,17.3-30,17.3 s-24-7-30-17.3c-3-5.1-4.7-11-4.7-17.3V35.2z"
}));

var SvgFishOutline = function SvgFishOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fishOutlineIcon",
    viewBox: "-2 -2 69.72 39.65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFishOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fish_outline.3b41fcaa.svg";
export { ForwardRef as ReactComponent };